import { useEffect } from 'react';

const useWhatapRumFO = () => {
  useEffect(() => {
    if (process.env.REACT_APP_ENV === 'prd') {
      (function (w, h, _a, t, a) {
        w = w[a] = w[a] || {
          config: {
            projectAccessKey: 'x2t0gmrevovi6-x1gbroiehpf82n-x6d338v2oqbksf',
            pcode: 116,
            sampleRate: 100,
            sessionReplaySampleRate: 100,
            sessionReplayMaskAllTexts: false,
            sessionReplayMaskAllInputs: true,
            proxyBaseUrl: 'https://rum.welstory.com/116/',
            ignoreErrors: ["Unauthorized"],
          },
        };
        a = h.createElement(_a);
        a.async = 1;
        a.src = t;
        t = h.getElementsByTagName(_a)[0];
        t.parentNode.insertBefore(a, t);
      })(window, document, 'script', 'https://rum.welstory.com/whatap-browser-agent.js', 'WhatapBrowserAgent', '');
    } else if (process.env.REACT_APP_ENV === 'stg') {
      (function (w, h, _a, t, a) {
        w = w[a] = w[a] || {
          config: {
            projectAccessKey: 'x2s8gpn5g07fj-z1oa3l53n9b2uo-x4p2c8oh62llq7',
            pcode: 113,
            sampleRate: 100,
            sessionReplaySampleRate: 100,
            sessionReplayMaskAllTexts: false,
            sessionReplayMaskAllInputs: true,
            proxyBaseUrl: 'https://rum.welstory.com/113/',
            ignoreErrors: ["Unauthorized"],
          },
        };
        a = h.createElement(_a);
        a.async = 1;
        a.src = t;
        t = h.getElementsByTagName(_a)[0];
        t.parentNode.insertBefore(a, t);
      })(window, document, 'script', 'https://rum.welstory.com/whatap-browser-agent.js', 'WhatapBrowserAgent', '');
    }
  }, []);
};

export default useWhatapRumFO;
